<script lang="ts" setup>
import { marked } from 'marked';

interface Props {
  markdown: string;
}

const props = defineProps<Props>();

// Sanitisation happens in KUICoreHtml, the single sink for raw HTML rendering
const formattedHtml = computed<string>(() => {
  return marked.parse(props.markdown, { async: false });
});
</script>

<template>
  <KUICoreHtml :html="formattedHtml" />
</template>
